import React from "react";
import { Helmet } from "react-helmet";
import Clientelle from "../components/home/Clientelle";
import OurWorks from "../components/home/OurWork";
import PageHero from "../components/reusables/hero/PageHero";
import ServicesBody from "../components/services/ServicesBody";

export default function Services() {
  return (
    <>
      <Helmet>
        <link
          rel="conanical"
          href="https://www.JMSTONELOGISTICS.com/services"
        />
        <meta
          name="description"
          content="JMSTONE Logistics is an earthworks construction company and leading supplier and installer of Geosynthetics, HDPEs and Institutional Uniforms"
        />
        <meta
          property="og:description"
          content="JMSTONE Logistics is an earthworks construction company and leading supplier and installer of Geosynthetics, HDPEs and Institutional Uniforms"
        />
        <meta property="og:title" content="Our Services - JMSTONE LOGISTICS" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1708492028/jmstonebanner_hoycxz.jpg"
        />

        <meta name="twitter:title" content="Our Services - JMSTONE LOGISTICS" />
        <meta
          name="twitter:text:title"
          content="Our Services - JMSTONE LOGISTICS"
        />
        <meta
          name="twitter:description"
          content="JMSTONE Logistics is an earthworks construction company and leading supplier and installer of Geosynthetics, HDPEs and Institutional Uniforms"
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1708492028/jmstonebanner_hoycxz.jpg"
        />
        <title>Our Services - JMSTONE LOGISTICS</title>
      </Helmet>
      <PageHero
        classes="doggy-bg"
        titleClasses="title uppercase white text-shadow"
        title="Our Services"
      />
      <ServicesBody />
      <Clientelle />
    </>
  );
}
